// import store from "@/store";
import type { RouteRecordRaw } from "vue-router";
import { createRouter, createWebHashHistory } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "ROOT",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "HOME",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/home/index.vue"),
  },
  {
    path: "/issue",
    name: "ISSUE",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/issue/index.vue"),
    meta: {
      title: "Contact us",
    },
  },
  {
    path: "/share",
    name: "SHARE",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/share/index.vue"),
    meta: {
      title: "SHARE",
    },
  },
  {
    path: "/secret",
    name: "SECRET",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/secret/index.vue"),
    meta: {
      title: "SECRET",
    },
  },
  {
    path: "/readme",
    name: "README",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/readme/index.vue"),
    meta: {
      title: "README",
    },
  },
  {
    path: "/rocnovel/app",
    name: "rocnovel",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/download/index.vue"),
    meta: {
      title: "README",
    },
  },
  {
    path: "/app/secret",
    name: "APPSECRET",
    component: () => import("../views/app/secret/index.vue"),
    meta: {
      title: "SECRET",
    },
  },
  {
    path: "/app/readme",
    name: "APPREADME",
    component: () => import("../views/app/readme/index.vue"),
    meta: {
      title: "README",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    // 判断是否有标题
    document.title = to.meta.title as string;
  } else {
    document.title = "";
  }
  next();
});

export default router;
